import {QueryCacheKeys} from '../../api/cache';
import {getInvoices} from '../../api/invoices';
import Layout from '../Layout';
import InvoiceTable from './InvoiceTable';
import {Button, Icon, Loader} from '@sproutsocial/racine';
import {useQuery} from '@tanstack/react-query';

const InvoiceList = () => {
	const {data: invoices} = useQuery({
		queryKey: QueryCacheKeys.invoices(),
		queryFn: () => getInvoices(),
	});

	if (!invoices) {
		return <Loader />;
	}

	return (
		<Layout>
			<Layout.Header title='Invoices'>
				<Button appearance='primary' href='/invoices/new'>
					<Icon name='plus' mr='space.300' /> New Invoice
				</Button>
			</Layout.Header>
			<Layout.Body>
				<InvoiceTable invoices={invoices} />
			</Layout.Body>
		</Layout>
	);
};

export default InvoiceList;
